import React, { useEffect, useState } from 'react';
import { Sun, Coins, Plug, Wifi, Globe2, Car, Plane, Shield, Heart, Utensils, Music, ShoppingBag, Thermometer, FileText, Stethoscope, Clock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { weddingData } from '../mockData';

const InfosCI = () => {
  const { language } = useLanguage();
  const content = weddingData[language].ivoryCoastInfo;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const cultureImages = [
    {
      src: "https://images.pexels.com/photos/1755718/pexels-photo-1755718.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      caption: language === 'fr' ? "Lagune tropicale" : "Tropical lagoon"
    },
    {
      src: "https://images.unsplash.com/photo-1722481744477-d0b0bb2bbba2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxBZnJpY2FuJTIwdHJhZGl0aW9uYWwlMjBkYW5jZSUyMGNlbGVicmF0aW9uJTIwY29sb3JmdWx8ZW58MHx8fHwxNzc0NTUwNzc2fDA&ixlib=rb-4.1.0&q=85",
      caption: language === 'fr' ? "Danses traditionnelles" : "Traditional dances"
    },
    {
      src: "https://images.unsplash.com/photo-1768212565426-58b089b6386d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxBZnJpY2FuJTIwbWFya2V0JTIwY29sb3JmdWwlMjBmYWJyaWMlMjB3YXglMjBwcmludHxlbnwwfHx8fDE3NzQ1NTA3OTN8MA&ixlib=rb-4.1.0&q=85",
      caption: language === 'fr' ? "Tissus wax et pagnes" : "Wax prints and fabrics"
    },
    {
      src: "https://images.unsplash.com/photo-1702827482556-481adcd68f3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxXZXN0JTIwQWZyaWNhbiUyMGZvb2QlMjBjdWlzaW5lJTIwY29sb3JmdWwlMjBkaXNofGVufDB8fHx8MTc3NDU1MDc4Nnww&ixlib=rb-4.1.0&q=85",
      caption: language === 'fr' ? "Gastronomie ivoirienne" : "Ivorian cuisine"
    },
    {
      src: "https://images.pexels.com/photos/7381784/pexels-photo-7381784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      caption: language === 'fr' ? "Abidjan moderne" : "Modern Abidjan"
    },
    {
      src: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/La_cath%C3%A9drale_Saint-Paul_Abidjan_03.jpg/1280px-La_cath%C3%A9drale_Saint-Paul_Abidjan_03.jpg",
      caption: language === 'fr' ? "Cathedrale Saint-Paul" : "Saint-Paul Cathedral"
    }
  ];

  const visaInfo = language === 'fr' ? [
    { country: "France", flag: "🇫🇷", info: "Pas de visa requis pour un sejour de moins de 90 jours. Passeport valide 6 mois apres la date de retour." },
    { country: "Canada", flag: "🇨🇦", info: "Visa obligatoire. Faire la demande en ligne ou aupres de l'ambassade. Delai de traitement : 5 a 10 jours ouvrables." },
    { country: "Etats-Unis", flag: "🇺🇸", info: "Visa obligatoire. Faire la demande en ligne ou aupres du consulat. Prevoir un delai de 2 semaines minimum." }
  ] : [
    { country: "France", flag: "🇫🇷", info: "No visa required for stays under 90 days. Passport must be valid 6 months beyond return date." },
    { country: "Canada", flag: "🇨🇦", info: "Visa required. Apply online or through the embassy. Processing time: 5 to 10 business days." },
    { country: "United States", flag: "🇺🇸", info: "Visa required. Apply online or through the consulate. Allow at least 2 weeks processing time." }
  ];

  const practicalCards = language === 'fr' ? [
    { icon: <Thermometer className="text-gold-500" size={28} />, title: "Climat", desc: "En aout, climat tropical humide. Temperatures entre 24 et 30 C. Prevoir un parapluie et des vetements legers." },
    { icon: <Coins className="text-gold-500" size={28} />, title: "Monnaie", desc: "Franc CFA (XOF). 1 EUR = ~656 XOF. 1 CAD = ~440 XOF. 1 USD = ~600 XOF. Change disponible a l'aeroport et dans les banques." },
    { icon: <Clock className="text-gold-500" size={28} />, title: "Fuseau horaire", desc: "GMT+0 (UTC). Pas de changement d'heure. Decalage : France -1h (ete) / 0h (hiver), Canada -4h a -8h, USA -4h a -8h." },
    { icon: <Plug className="text-gold-500" size={28} />, title: "Electricite", desc: "Prises de type C et E (europeennes). 220V / 50Hz. Les voyageurs nord-americains auront besoin d'un adaptateur." },
    { icon: <Globe2 className="text-gold-500" size={28} />, title: "Langue", desc: "Le francais est la langue officielle. Vous serez a l'aise partout. L'anglais est compris dans les grands hotels." },
    { icon: <Wifi className="text-gold-500" size={28} />, title: "Connexion", desc: "Wi-Fi disponible dans les hotels et restaurants. Cartes SIM locales (Orange, MTN, Moov) en vente a l'aeroport." },
    { icon: <Car className="text-gold-500" size={28} />, title: "Transports", desc: "Uber et Yango sont les plus pratiques. Taxis disponibles partout. Prevoir 20 a 40 min aeroport-Cocody selon le trafic." },
    { icon: <Shield className="text-gold-500" size={28} />, title: "Securite", desc: "Abidjan est une ville sure dans les quartiers residentiels (Cocody, Deux Plateaux). Evitez de vous deplacer seul(e) tard le soir." }
  ] : [
    { icon: <Thermometer className="text-gold-500" size={28} />, title: "Climate", desc: "In August, tropical humid climate. Temperatures between 24 and 30 C. Bring an umbrella and light clothing." },
    { icon: <Coins className="text-gold-500" size={28} />, title: "Currency", desc: "CFA Franc (XOF). 1 EUR = ~656 XOF. 1 CAD = ~440 XOF. 1 USD = ~600 XOF. Exchange available at the airport and banks." },
    { icon: <Clock className="text-gold-500" size={28} />, title: "Time zone", desc: "GMT+0 (UTC). No daylight saving. Difference: France -1h (summer) / 0h (winter), Canada -4h to -8h, USA -4h to -8h." },
    { icon: <Plug className="text-gold-500" size={28} />, title: "Electricity", desc: "Type C and E plugs (European). 220V / 50Hz. North American travelers will need an adapter." },
    { icon: <Globe2 className="text-gold-500" size={28} />, title: "Language", desc: "French is the official language. You'll feel comfortable everywhere. English is understood in major hotels." },
    { icon: <Wifi className="text-gold-500" size={28} />, title: "Connectivity", desc: "Wi-Fi available in hotels and restaurants. Local SIM cards (Orange, MTN, Moov) sold at the airport." },
    { icon: <Car className="text-gold-500" size={28} />, title: "Transport", desc: "Uber and Yango are the most practical. Taxis available everywhere. Allow 20-40 min airport to Cocody depending on traffic." },
    { icon: <Shield className="text-gold-500" size={28} />, title: "Safety", desc: "Abidjan is safe in residential areas (Cocody, Deux Plateaux). Avoid traveling alone late at night." }
  ];

  const cuisineHighlights = language === 'fr' ? [
    { name: "Attieke", desc: "Semoule de manioc, accompagnement incontournable" },
    { name: "Alloco", desc: "Bananes plantains frites, un delice a toute heure" },
    { name: "Poulet braise", desc: "Le plat emblematique, grille au feu de bois" },
    { name: "Garba", desc: "Attieke et thon frit, le street food par excellence" },
    { name: "Kedjenou", desc: "Poulet ou pintade mijote aux legumes" },
    { name: "Jus de bissap", desc: "Boisson rafraichissante a base de fleurs d'hibiscus" }
  ] : [
    { name: "Attieke", desc: "Cassava semolina, the essential side dish" },
    { name: "Alloco", desc: "Fried plantain, a delight at any time" },
    { name: "Grilled Chicken", desc: "The iconic dish, wood-fire grilled" },
    { name: "Garba", desc: "Attieke and fried tuna, the ultimate street food" },
    { name: "Kedjenou", desc: "Chicken or guinea fowl stewed with vegetables" },
    { name: "Bissap Juice", desc: "Refreshing hibiscus flower drink" }
  ];

  return (
    <div className="min-h-screen pt-24 pb-20 bg-ivory">
      {/* Hero */}
      <section className="relative h-[70vh] min-h-[500px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={cultureImages[0].src}
            alt="Abidjan"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-plum-900/60 via-plum-900/40 to-plum-900/70" />
        </div>
        <div className={`relative z-10 h-full flex flex-col items-center justify-center text-center px-6 transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <Plane className="text-gold-400 mb-6" size={56} />
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-playfair font-bold text-white mb-4">
            {content.title}
          </h1>
          <p className="text-xl sm:text-2xl text-gold-300 font-montserrat mb-3">
            {content.subtitle}
          </p>
          <p className="text-lg text-white/80 font-montserrat max-w-3xl">
            {language === 'fr'
              ? "Tout ce que vous devez savoir pour profiter pleinement de votre sejour en Cote d'Ivoire"
              : "Everything you need to know to fully enjoy your stay in Ivory Coast"}
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-gold-400 to-transparent mx-auto rounded-full mt-8" />
        </div>
      </section>

      {/* Culture Gallery */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-plum-900 mb-3">
              {language === 'fr' ? "Decouvrir la Cote d'Ivoire" : "Discover Ivory Coast"}
            </h2>
            <p className="text-plum-600 font-montserrat">
              {language === 'fr'
                ? "Entre traditions ancestrales et modernite vibrante"
                : "Between ancestral traditions and vibrant modernity"}
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-6xl mx-auto">
            {cultureImages.map((img, index) => (
              <div
                key={index}
                className={`relative overflow-hidden rounded-2xl group ${index === 0 ? 'row-span-2' : ''}`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <img
                  src={img.src}
                  alt={img.caption}
                  className={`w-full object-cover group-hover:scale-110 transition-transform duration-700 ${index === 0 ? 'h-full min-h-[300px]' : 'h-48 sm:h-56'}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <p className="absolute bottom-3 left-3 text-white font-montserrat text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  {img.caption}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Visa Info per Country */}
      <section className="py-16 sm:py-20 bg-gradient-to-b from-lilac-50/50 to-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="text-center mb-12">
            <FileText className="mx-auto text-gold-500 mb-4" size={40} />
            <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-plum-900 mb-3">
              {language === 'fr' ? "Visa et documents" : "Visa and documents"}
            </h2>
            <p className="text-plum-600 font-montserrat">
              {language === 'fr' ? "Selon votre pays de residence" : "Based on your country of residence"}
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {visaInfo.map((v, index) => (
              <div key={index} className="card-premium p-6 text-center hover-lift" data-testid={`visa-card-${index}`}>
                <span className="text-4xl mb-4 block">{v.flag}</span>
                <h3 className="text-lg font-playfair font-bold text-plum-900 mb-3">{v.country}</h3>
                <p className="text-plum-700 font-montserrat text-sm leading-relaxed">{v.info}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Practical Info Cards */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-plum-900 mb-3">
              {language === 'fr' ? "Informations pratiques" : "Practical information"}
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
            {practicalCards.map((card, index) => (
              <div
                key={index}
                className={`card-premium p-6 hover-lift transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 80}ms` }}
                data-testid={`practical-card-${index}`}
              >
                <div className="w-12 h-12 mb-4 bg-gradient-to-br from-lilac-100 to-gold-50 rounded-xl flex items-center justify-center">
                  {card.icon}
                </div>
                <h3 className="text-base font-playfair font-bold text-plum-900 mb-2">{card.title}</h3>
                <p className="text-plum-700 font-montserrat text-sm leading-relaxed">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cuisine Section */}
      <section className="py-16 sm:py-20 bg-gradient-to-b from-gold-50/50 to-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-10 items-center">
              <div>
                <Utensils className="text-gold-500 mb-4" size={36} />
                <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-plum-900 mb-4">
                  {language === 'fr' ? "La cuisine ivoirienne" : "Ivorian cuisine"}
                </h2>
                <p className="text-plum-700 font-montserrat mb-8 leading-relaxed">
                  {language === 'fr'
                    ? "La gastronomie ivoirienne est riche et genereuse. Voici quelques incontournables a decouvrir pendant votre sejour."
                    : "Ivorian cuisine is rich and generous. Here are some must-try dishes during your stay."}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {cuisineHighlights.map((dish, index) => (
                    <div key={index} className="flex items-start gap-3 p-3 rounded-xl bg-white border border-gold-100 shadow-soft">
                      <div className="w-2 h-2 mt-2 rounded-full bg-gold-500 shrink-0" />
                      <div>
                        <p className="font-montserrat font-bold text-plum-900 text-sm">{dish.name}</p>
                        <p className="font-montserrat text-plum-600 text-xs">{dish.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <img
                  src={cultureImages[3].src}
                  alt="Cuisine"
                  className="w-full h-48 sm:h-64 object-cover rounded-2xl"
                />
                <img
                  src="https://images.pexels.com/photos/36707708/pexels-photo-36707708.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt="Cuisine preparation"
                  className="w-full h-48 sm:h-64 object-cover rounded-2xl mt-8"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ambiance & Music */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <Music className="mx-auto text-gold-500 mb-4" size={36} />
              <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-plum-900 mb-3">
                {language === 'fr' ? "Musique et ambiance" : "Music and atmosphere"}
              </h2>
              <p className="text-plum-600 font-montserrat max-w-2xl mx-auto">
                {language === 'fr'
                  ? "La Cote d'Ivoire est un berceau musical. Du coupe-decale au zouglou en passant par l'afrobeat, la musique fait partie de la vie quotidienne."
                  : "Ivory Coast is a musical cradle. From coupe-decale to zouglou and afrobeat, music is part of daily life."}
              </p>
            </div>
            <div className="grid sm:grid-cols-3 gap-6">
              {(language === 'fr' ? [
                { title: "Coupe-Decale", desc: "Ne musical ivoirien, reconnu mondialement pour son energie et sa joie communicative." },
                { title: "Zouglou", desc: "Musique populaire nee dans les universites, qui raconte avec humour le quotidien ivoirien." },
                { title: "Afrobeat & Amapiano", desc: "La scene moderne d'Abidjan vibre au rythme de ces genres qui fusionnent tradition et modernite." }
              ] : [
                { title: "Coupe-Decale", desc: "Ivorian musical genre, globally recognized for its energy and infectious joy." },
                { title: "Zouglou", desc: "Popular music born in universities, humorously narrating everyday Ivorian life." },
                { title: "Afrobeat & Amapiano", desc: "Abidjan's modern scene pulses with these genres that fuse tradition and modernity." }
              ]).map((item, index) => (
                <div key={index} className="card-premium p-6 text-center hover-lift">
                  <h3 className="text-base font-playfair font-bold text-plum-900 mb-3">{item.title}</h3>
                  <p className="text-plum-700 font-montserrat text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Elephants & Lieux touristiques */}
      <section className="py-16 sm:py-20 bg-gradient-to-b from-gold-50/30 to-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-plum-900 mb-3">
              {language === 'fr' ? "Joyaux de Cote d'Ivoire" : "Ivory Coast gems"}
            </h2>
            <p className="text-plum-600 font-montserrat max-w-2xl mx-auto">
              {language === 'fr'
                ? "Entre nature majestueuse et paysages a couper le souffle"
                : "Between majestic nature and breathtaking landscapes"}
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-6xl mx-auto" data-testid="tourism-gallery">
            {[
              {
                src: "https://images.pexels.com/photos/5125391/pexels-photo-5125391.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
                caption: language === 'fr' ? "Elephants au coucher du soleil" : "Elephants at sunset",
                span: "col-span-2 md:col-span-1 md:row-span-2"
              },
              {
                src: "https://images.unsplash.com/photo-1768205250679-37ce763e98c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHx0cm9waWNhbCUyMGJlYWNoJTIwcGFsbSUyMHRyZWVzJTIwdHVycXVvaXNlJTIwd2F0ZXIlMjBBZnJpY2ElMjBwYXJhZGlzZXxlbnwwfHx8fDE3NzQ1OTU1MzF8MA&ixlib=rb-4.1.0&q=85",
                caption: language === 'fr' ? "Plages paradisiaques" : "Paradise beaches",
                span: ""
              },
              {
                src: "https://images.pexels.com/photos/7381958/pexels-photo-7381958.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
                caption: language === 'fr' ? "Abidjan vue du ciel" : "Abidjan from above",
                span: ""
              },
              {
                src: "https://images.pexels.com/photos/5051403/pexels-photo-5051403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
                caption: language === 'fr' ? "Elephants dans la savane" : "Elephants in the savanna",
                span: ""
              },
              {
                src: "https://images.pexels.com/photos/238631/pexels-photo-238631.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
                caption: language === 'fr' ? "Foret tropicale du Banco" : "Banco tropical forest",
                span: ""
              },
              {
                src: "https://images.pexels.com/photos/5642426/pexels-photo-5642426.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
                caption: language === 'fr' ? "Lagune d'Abidjan" : "Abidjan lagoon",
                span: "col-span-2 md:col-span-1"
              }
            ].map((item, index) => (
              <div
                key={index}
                className={`relative overflow-hidden rounded-2xl group cursor-pointer ${item.span}`}
                style={{ transitionDelay: `${index * 80}ms` }}
                data-testid={`tourism-photo-${index}`}
              >
                <img
                  src={item.src}
                  alt={item.caption}
                  className={`w-full object-cover group-hover:scale-110 transition-transform duration-700 ${item.span.includes('row-span-2') ? 'h-full min-h-[280px]' : 'h-52 sm:h-60'}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-plum-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500" />
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                  <p className="text-white font-montserrat text-sm font-semibold drop-shadow-lg">
                    {item.caption}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Fashion & Art */}
      <section className="py-16 sm:py-20 bg-gradient-to-b from-lilac-50/50 to-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-10 items-center">
              <div className="order-2 lg:order-1">
                <img
                  src={cultureImages[2].src}
                  alt="Mode"
                  className="w-full h-72 sm:h-96 object-cover rounded-2xl shadow-medium"
                />
              </div>
              <div className="order-1 lg:order-2">
                <ShoppingBag className="text-gold-500 mb-4" size={36} />
                <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-plum-900 mb-4">
                  {language === 'fr' ? "Mode et artisanat" : "Fashion and craftsmanship"}
                </h2>
                <p className="text-plum-700 font-montserrat mb-6 leading-relaxed">
                  {language === 'fr'
                    ? "La Cote d'Ivoire est une reference en matiere de mode africaine. Les tissus wax, les pagnes et les creations de designers ivoiriens sont reconnus sur la scene internationale."
                    : "Ivory Coast is a reference in African fashion. Wax fabrics, pagnes and Ivorian designer creations are recognized on the international scene."}
                </p>
                <div className="space-y-3">
                  {(language === 'fr' ? [
                    "Les marches de Treichville et Adjame pour les tissus",
                    "Les boutiques de createurs a Cocody et Deux Plateaux",
                    "L'artisanat : masques, bijoux, sculptures en bois"
                  ] : [
                    "Treichville and Adjame markets for fabrics",
                    "Designer boutiques in Cocody and Deux Plateaux",
                    "Craftsmanship: masks, jewelry, wood sculptures"
                  ]).map((item, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <div className="w-2 h-2 rounded-full bg-gold-500 shrink-0" />
                      <p className="font-montserrat text-plum-800 text-sm">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lieux à découvrir */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="text-center mb-10">
            <Heart className="mx-auto text-gold-500 mb-4" size={36} />
            <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-plum-900 mb-3">
              {language === 'fr' ? "A ne pas manquer" : "Don't miss"}
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {(language === 'fr' ? [
              { name: "La Cathedrale Saint-Paul", desc: "Chef-d'oeuvre architectural du Plateau, un lieu emblematique d'Abidjan." },
              { name: "Le Musee des Civilisations", desc: "Plongee dans l'histoire et les traditions des peuples de Cote d'Ivoire." },
              { name: "La Baie de Cocody", desc: "Promenade en bord de lagune, un cadre paisible au coeur de la ville." },
              { name: "Le Parc du Banco", desc: "Foret tropicale en plein coeur d'Abidjan, ideal pour une escapade nature." },
              { name: "Grand-Bassam", desc: "Ville historique classee UNESCO, a 30 min d'Abidjan. Plages et architecture coloniale." },
              { name: "Ile Boulay", desc: "Ile sur la lagune, accessible en bateau. Ambiance decontractee et restaurants locaux." }
            ] : [
              { name: "Saint-Paul Cathedral", desc: "Architectural masterpiece in Plateau, an iconic Abidjan landmark." },
              { name: "Museum of Civilizations", desc: "Dive into the history and traditions of Ivory Coast peoples." },
              { name: "Cocody Bay", desc: "A lagoon-side walk, a peaceful setting in the heart of the city." },
              { name: "Banco National Park", desc: "Tropical forest in the heart of Abidjan, perfect for a nature escape." },
              { name: "Grand-Bassam", desc: "UNESCO historic town, 30 min from Abidjan. Beaches and colonial architecture." },
              { name: "Boulay Island", desc: "Lagoon island accessible by boat. Relaxed atmosphere and local restaurants." }
            ]).map((place, index) => (
              <div key={index} className="card-premium p-6 hover-lift">
                <h3 className="text-base font-playfair font-bold text-plum-900 mb-2">{place.name}</h3>
                <p className="text-plum-700 font-montserrat text-sm leading-relaxed">{place.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Health Tips */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <Stethoscope className="mx-auto text-gold-500 mb-4" size={36} />
              <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-plum-900 mb-3">
                {language === 'fr' ? "Sante et bien-etre" : "Health and wellness"}
              </h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="p-6 bg-lilac-50/50 rounded-2xl border border-lilac-100">
                <h3 className="text-base font-playfair font-bold text-plum-900 mb-3">
                  {language === 'fr' ? "Vaccinations" : "Vaccinations"}
                </h3>
                <p className="text-plum-700 font-montserrat text-sm leading-relaxed">
                  {language === 'fr'
                    ? "Le vaccin contre la fievre jaune est obligatoire. Mettez a jour vos vaccins courants (hepatite A/B, typhoide). Consultez votre medecin au moins 6 semaines avant le depart."
                    : "Yellow fever vaccination is mandatory. Update your routine vaccines (hepatitis A/B, typhoid). Consult your doctor at least 6 weeks before departure."}
                </p>
              </div>
              <div className="p-6 bg-lilac-50/50 rounded-2xl border border-lilac-100">
                <h3 className="text-base font-playfair font-bold text-plum-900 mb-3">
                  {language === 'fr' ? "Precautions" : "Precautions"}
                </h3>
                <p className="text-plum-700 font-montserrat text-sm leading-relaxed">
                  {language === 'fr'
                    ? "Traitement antipaludique fortement conseille. Buvez de l'eau en bouteille. Utilisez un anti-moustiques. Les pharmacies et cliniques sont facilement accessibles a Abidjan."
                    : "Antimalarial treatment strongly recommended. Drink bottled water. Use mosquito repellent. Pharmacies and clinics are easily accessible in Abidjan."}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-br from-lilac-100 via-lilac-200 to-lilac-100 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 left-10 w-40 h-40 bg-gold-200 rounded-full filter blur-3xl animate-float" />
          <div className="absolute bottom-10 right-10 w-40 h-40 bg-lilac-100 rounded-full filter blur-3xl animate-float" style={{ animationDelay: '2s' }} />
        </div>
        <div className="container mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-3xl font-playfair font-bold text-plum-900 mb-6">
              {language === 'fr' ? "Besoin d'aide pour organiser votre voyage ?" : "Need help organizing your trip?"}
            </h3>
            <p className="text-lg text-plum-800 font-montserrat mb-8">
              {language === 'fr'
                ? "N'hesitez pas a nous contacter, nous serons ravis de vous aider."
                : "Feel free to contact us, we'll be happy to help."}
            </p>
            <a
              href="mailto:cyrilleneninbi@gmail.com"
              className="btn-primary inline-block"
              data-testid="contact-button"
            >
              {language === 'fr' ? 'Nous contacter' : 'Contact Us'}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InfosCI;
